// Custom hook for scroll-based animations
import { useEffect } from 'react';

export const useScrollAnimations = () => {
  useEffect(() => {
    // Animate elements on scroll using Intersection Observer
    const animateOnScroll = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Get the original animation class from the element
          const animationClasses = ['animate-fadeInUp', 'animate-fadeInLeft', 'animate-fadeInRight', 'animate-scaleIn'];
          const elementClasses = entry.target.classList;
          
          // Find which animation class the element has
          animationClasses.forEach(animClass => {
            if (elementClasses.contains(animClass)) {
              // Re-add the class to trigger the animation
              entry.target.classList.remove(animClass);
              requestAnimationFrame(() => {
                entry.target.classList.add(animClass);
              });
            }
          });
          
          observer.unobserve(entry.target);
        }
      });
    };

    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px 0px -50px 0px', // Trigger slightly before element is fully visible
      threshold: 0.15 // Trigger when 15% of the element is visible
    };

    const observer = new IntersectionObserver(animateOnScroll, observerOptions);

    // Observe all elements with animation classes
    const animationSelectors = [
      '.animate-fadeInUp',
      '.animate-fadeInLeft', 
      '.animate-fadeInRight',
      '.animate-scaleIn'
    ];
    
    animationSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        observer.observe(element);
      });
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useScrollAnimations;